import angular from 'angular';
const componentOptions = {
    bindings: {
        model: '=',
        containerForm: '=',
        show: '<'
    },
    controllerAs : 'giftCardsSenderDetailsCtrl',
    templateUrl: ['GiftCardsAppConstants', (GiftCardsAppConstants: GiftCardsAppConstant): string => `${GiftCardsAppConstants.templatesRoute}ib-gift-cards-sender-details-view.html`]
};
const componentInfo = {
    module: 'ib-gift-cards-configuration-form-module',
    selector: 'ibGiftCardsSenderDetails',
    inject:['GiftCardsAppConstants'],
    required: []
};
export class ibGiftCardsSenderDetails implements ng.IController {
    public model: Types.DestinataryInfo;
    public MAX_LENGTH_NAME : number;
    public NAME_SURNAME_PATTERN: RegExp;
    public NAME_SURNAME_CLEANER: string;
    public EMAIL_PATTERN: RegExp;
    constructor (private GiftCardsAppConstants: GiftCardsAppConstant) {
        this.MAX_LENGTH_NAME = this.GiftCardsAppConstants.MAX_FIELD_LENGTH.MAX_LENGTH_NAME;
        this.NAME_SURNAME_PATTERN = this.GiftCardsAppConstants.PATTERNS.NAME_SURNAME_PATTERN;
        this.NAME_SURNAME_CLEANER = this.GiftCardsAppConstants.PATTERNS.NAME_SURNAME_CLEANER;
        this.EMAIL_PATTERN = this.GiftCardsAppConstants.PATTERNS.EMAIL_PATTERN;
    }
}
try {
    const mod = angular.module(componentInfo.module);
    ibGiftCardsSenderDetails.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsSenderDetails })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibGiftCardsSenderDetails.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsSenderDetails })
    );
}
